const SvgIconDoc = (props) => (
  <svg viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3193_26555)">
      <path d="M14 2.5H6C4.9 2.5 4.01 3.4 4.01 4.5L4 20.5C4 21.6 4.89 22.5 5.99 22.5H18C19.1 22.5 20 21.6 20 20.5V8.5L14 2.5ZM16 18.5H8V16.5H16V18.5ZM16 14.5H8V12.5H16V14.5ZM13 9.5V4L18.5 9.5H13Z" />
    </g>
    <defs>
      <clipPath id="clip0_3193_26555">
        <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgIconDoc;
